import { useCallback, useEffect, useState } from 'react'

import { useTranslation } from 'react-i18next'

import { getAppUrl } from '@app/components/AppSmartBanner/helpers'
import config from '@app/config'
import { getCookie, setCookie } from '@app/services'
import { isIos } from '@app/utils'

import { Icon } from '@lib/components'

import { IconStyles } from '@lib/components/Icon/styles'

import styles from './styles.module.scss'

const setSmartBannerHeight = (height: number) => {
  if (typeof document === 'undefined') {
    return
  }

  document.documentElement.style.setProperty('--smart-banner-height', `${height}px`)
}

export const GenericBanner = () => {
  const { t } = useTranslation()
  const [visible, setVisible] = useState(false)
  const isInWebView = config.identity.isWebView
  const bannerDismissed = !!getCookie(config.variables.dismiss_app_banner)
  const handleCloseBanner = useCallback(() => {
    setVisible(false)
    setSmartBannerHeight(0)
    setCookie(config.variables.dismiss_app_banner, 'true', 24 * 30)
  }, [])

  useEffect(() => {
    const isAndroidNavigator = /Android/.test(navigator.userAgent)
    const isIosNonSafariNavigator = /(iPhone|iPad).+(CriOS|EdgiOS|FxiOS)/.test(
      navigator.userAgent
    )
    if (
      (isAndroidNavigator ||
        isIosNonSafariNavigator ||
        window.location.href.includes('localhost')) &&
      !bannerDismissed &&
      !isInWebView
    ) {
      setVisible(true)
      setSmartBannerHeight(60)
    } else {
      setSmartBannerHeight(0)
    }

    return () => {
      setSmartBannerHeight(0)
    }
  }, [bannerDismissed, isInWebView])

  if (!visible) return null

  return (
    <div className={styles.smartBanner}>
      <div className={styles.appWrap}>
        <button
          type="button"
          className={styles.closeBtn}
          onClick={handleCloseBanner}
        >
          <Icon path="icons/icon-close-white" style={IconStyles.small} />
        </button>
        <Icon path="properstar-app-logo" />
        <div className={styles.smartBannerContent}>
          <div className={styles.appName}> Properstar </div>
          <div className={styles.appDescription}>
            {t(isIos() ? 'Common.Stores.AppStore' : 'Common.Stores.GooglePlay')}
          </div>
        </div>
      </div>
      <a
        href={getAppUrl()}
        className={styles.downloadBtn}
        target="_blank"
        rel="noopener noreferrer"
        data-gtm-click="smart-banner-open"
      >
        <button type="button" className={styles.openBtn}>
          {t('Common.Button.Open')}
        </button>
      </a>
    </div>
  )
}
